import * as Scrivito from "scrivito";
import { getKeycloak } from "^/Components/Authentication/keycloak";

export const scheduleTokenRefresh = () => {
  const keycloak = getKeycloak();

  const refresh = async () => {
    try {
      const refreshed = await keycloak.updateToken(30);

      if (refreshed) {
        Scrivito.setVisitorIdToken(keycloak.idToken);
      }
    } catch (err) {
      console.error("Token refresh failed", err);
      window.localStorage.setItem("keycloakLoginPresent", "false");
      keycloak.logout();
    }
  };

  const loop = async () => {
    await refresh();
    setTimeout(loop, 10000);
  };

  loop();
};
